import { render, staticRenderFns } from "./NewFlowDownTemplate.vue?vue&type=template&id=4a64546c"
import script from "./NewFlowDownTemplate.vue?vue&type=script&lang=js"
export * from "./NewFlowDownTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports